import Storage from './storage'

/**
 * @class S3Storage
 * @extends {Storage}
 */
export default class S3Storage extends Storage {
    constructor() {
        super()

        this.config = require('../../../config').default //eslint-disable-line global-require
        this.AWS = require('aws-sdk') //eslint-disable-line global-require
    }
    upload(name, data) {
        const storage = new this.AWS.S3({ apiVersion: '2006-03-01' })
        const [Body, Key, Bucket] = [data, name, this.config.whitelistQueueBucket]
        return storage.putObject({ Body, Key, Bucket }).promise()
    }
}
